module.exports = __webpack_public_path__ + "img/mall_qrcode.af6ee61.jpg";